<template>
    <div class="view">
      <div class="leftbar col-xs-12 col-sm-12 col-md-3 col-lg-3">
        <div v-html="menu"></div>
        <a class="twitter-timeline" data-height="600" href="https://twitter.com/OSIRIS_CES?ref_src=twsrc%5Etfw">Tweets by OSIRIS_CES</a>
        <div class="fb-page" data-href="https://www.facebook.com/observatoriodorisco/" data-tabs="timeline" data-width="" data-height="" data-small-header="false" data-adapt-container-width="true" data-hide-cover="false" data-show-facepile="true"><blockquote cite="https://www.facebook.com/observatoriodorisco/" class="fb-xfbml-parse-ignore"><a href="https://www.facebook.com/observatoriodorisco/">OSIRIS</a></blockquote></div>
        <!-- <div class="newsletter">
          <br>
          <div style="margin-left:20%;margin-bottom:-35px;font: 8pt verdana, trebuchet MS, helvetica, sans-serif;">subscreva e receba informações actualizadas do OSIRIS &gt; mail</div>
            <img src="https://www.ces.uc.pt/osiris/templates/osiris/images/divulgacao.jpg" style="margin-left:3%;">
            
            <form name="nl" method="post" action="https://www.ces.uc.pt/cgi-bin/mailman/subscribe/infoosiris" enctype="application/x-www-form-urlencoded" style="margin-top:20px;">
              <input type="text" name="email" value="" style="width: 60%;margin-left:20%;">
              <input name="imageField2" type="image" onclick="popsubmit();return false;" src="https://www.ces.uc.pt/osiris/templates/osiris/images/pesquisar_ok.jpg">
            </form>
            <div class="social-media">
              <a href="https://www.flickr.com/people/157816548@N08/" target="_blank"><img src="https://www.ces.uc.pt/osiris/media/flickr.png" width="40" alt=""></a>
              <a href="https://www.facebook.com/observatoriodorisco/" target="_blank"><img src="https://www.ces.uc.pt/osiris/media/fb.png" width="40" alt=""></a>
            </div>
          </div> -->
      </div>

      <div class="center col-xs-12 col-sm-12 col-md-9 col-lg-9">
          <div class="pagetitle">
            {{ content.id_pagina === '17648' ? '' : content.title }}
          </div>

          <div class="center-content">
            <iframe src="https://www.ces.uc.pt/osiris/site/api.php/17643/1/get-legislacao" class="legislacao" v-if="legislacao"></iframe>

            <div v-html="content.content"></div>
            
            <!-- <img v-img:name v-for="(img, index) in imgs" :key="index" :src="img" class="portfolio_img">-->

            <div v-for="photoset in photosets" :key="photoset.id">
              <a 
                data-flickr-embed="true" 
                data-header="false" 
                data-footer="true" 
                href="https://www.flickr.com/photos/157816548@N08/albums/72157690455141446" 
                :title="photoset.title._content">
                  <img 
                    :src="`https://farm5.staticflickr.com/${photoset.server}/${photoset.primary}_${photoset.secret}.jpg`"
                    width="500" 
                    height="375" 
                    :alt="photoset.title._content">
              </a>
              <div v-html="photoset.title._content" class="photoset-title"></div>
              <div v-html="photoset.description._content" class="photoset-description"></div>
            </div>

            <div class="project" v-if="prj">
              <div class="project-title">
                <span v-if="prj.acronimo"> {{ prj.acronimo }} - </span>
                  {{ prj.titulo }}
              </div>
              <div class="project-periodo" v-if="prj.data_ext">Período <br/><br/>
                <div>{{ prj.data_ext }}</div>
              </div>              
              <div class="project-duracao" v-if="prj.duracao"> Duração <br/><br/>
                <div>{{ prj.duracao }} meses</div>
              </div>
              <div class="project-resumo" v-if="prj.resumo"> Resumo
                <span v-html="prj.resumo"></span>
              </div>              
              <div class="project-resultados" v-if="prj.resultados"> Resultados
                <span v-html="prj.resultados"></span>
              </div>
              <div class="project-funding">
                Financiamento:
              </div>
              <ul>
                <li>
                  <span v-for="(institution, idx) in prj.instituicoes" :key="idx">
                    <span>{{ institution.nome }}</span><span v-if="idx < prj.instituicoes.length - 1">, </span>
                  </span>
                </li>
              </ul>

              <div class="project-parceiros" v-if="prj.parceiros"> Parceiros
                <span v-html="prj.parceiros"></span>
              </div>

              <div class="project-people">
                Investigadoras/es:
              </div>
              <ul>
                <li>
                  <span v-for="(person, idx) in prj.pessoas" :key="idx">
                    <span v-if="person.url"><a :href="person.url">{{ person.assinatura }}</a></span><span v-if="!person.url">{{ person.assinatura }}</span><br/>
                  </span>
                </li>
              </ul>

              <div class="project-keywords">
                Palavras-chave:
              </div>
              <ul>
                <li>
                  <span v-for="(palavra, idx) in prj.palavras" :key="idx">
                    <span>{{ palavra.palavra }}</span><span v-if="idx < prj.palavras.length - 1">, </span>
                  </span>
                </li>
              </ul>

            </div>

            <div v-for="(ano, index) in projects" :key="index" class="projects">
              <div>
                <div class="ano">
                  <span v-if="ano.key === '0'">
                    Projectos em Curso
                  </span>
                  <span v-if="ano.key > 0">
                    Concluídos em {{ ano.key }}
                  </span>
                </div>
                <div v-for="(prj, index) in ano.value" :key="index" class="projects">
                  <div v-if="!prj.data_ext">
                    <div class="projects-title">
                      <span v-if="prj.acronimo"> {{ prj.acronimo }} - </span>
                      {{ prj.titulo }}
                    </div>
                    <div v-html="prj.resumo"></div>
                  </div>
                  <div v-else>
                    <div class="projects-title">
                      <a :href="'?prj=' + prj.id_projecto">
                        <span v-if="prj.acronimo"> {{ prj.acronimo }} - </span>
                        {{ prj.titulo }}
                      </a>
                    </div>
                    <ul>
                      <li>
                        <div class="projects-people">
                          <strong>Investigadoras/es:</strong>
                        </div>
                        <ul>
                          <li>
                            <span v-for="(person, idx) in prj.pessoas" :key="idx">
                              <span v-if="person.url"><a :href="person.url">{{ person.assinatura }}</a></span><span v-if="!person.url">{{ person.assinatura }}</span><span v-if="idx < prj.pessoas.length - 1">, </span>
                            </span>
                          </li>
                        </ul>
                      </li>
                      <li>
                        <div class="projects-funding">
                          <strong>Financiamento:</strong>
                        </div>
                        <ul>
                          <li>
                            <span v-for="(institution, idx) in prj.instituicoes" :key="idx">
                              <span>{{ institution.nome }}</span><span v-if="idx < prj.instituicoes.length - 1">, </span>
                            </span>
                          </li>
                        </ul>
                      </li>
                      <li>
                        <div class="projects-time">
                          <strong>Período:</strong>
                        </div>
                        <ul>
                          <li>
                             <span>{{ prj.data_ext }}</span>
                          </li>
                        </ul>
                      </li>
                      <li>
                        <div class="projects-keywords">
                          <strong>Palavras-chave:</strong>
                        </div>
                        <ul>
                          <li>
                            <span v-for="(palavra, idx) in prj.palavras" :key="idx">
                              <span>{{ palavra.palavra }}</span><span v-if="idx < prj.palavras.length - 1">, </span>
                            </span>
                          </li>
                        </ul>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
      </div>

      <div class="rightbar col-xs-12 col-sm-12 col-md-3 col-lg-3">
        <div v-html="secondary_menu"></div>
        <carousel v-if="content.id_pagina === '17648'" :perPage="1" class="carousel" :autoplay="true">
          <slide v-for="destaque in galeriaDestaques" :key="destaque.id_pagina">
            <div v-html="destaque.texto"></div>
            <div class="carousel-titulo">
              <div v-html="destaque.item_menu"></div>
              <span v-html="destaque.titulo" v-if="destaque.item_menu !== destaque.titulo" class="carousel-subtitulo"></span>  
            </div>
            
          </slide>
        </carousel>
      </div>
    </div>
</template>

<script>
import axios from 'axios'
import { Carousel, Slide } from 'vue-carousel'

export default {
  name: 'content',
  components: {
    Carousel,
    Slide
  },
  data () {
    return {
      menu: '',
      secondary_menu: '',
      content: '',
      legislacao: false,
      imgs: [],
      prjs: [],
      prj: null,
      photosets: [],
      galeriaDestaques: []
    }
  },
  computed: {
    projects: function () {
      if (this.prjs.length === 0) {
        return null
      }
      let res = this.prjs.reduce(function (r, a) {
        r[a.ano_conclusao] = r[a.ano_conclusao] || []
        r[a.ano_conclusao].push(a)
        return r
      }, Object.create(null))

      let res2 = []

      for (var key in res) {
        res2.push({
          key: key,
          value: res[key]
        })
      }

      let prjs = res2.slice(1).reverse()
      prjs.unshift(res2[0])

      return prjs
    }
  },
  mounted () {
    axios.get('https://www.ces.uc.pt/osiris/site/api.php/17643/1/get-menu')
    .then(response => {
      this.menu = response.data
    })
   .catch(error => {
     console.log(error.data.error.message)
   })

    axios.get('https://www.ces.uc.pt/osiris/site/api.php/17643/1/get-galeria-destaques')
    .then(response => {
      this.galeriaDestaques = response.data
    })
   .catch(error => {
     console.log(error.data.error.message)
   })

    this.mainContent()
    this.submenu()
  },
  beforeUpdate () {
    // this.mainContent()
    this.submenu()
  },
  // watch: {
  //   prjs: function (pjs) {
  //     let res = pjs.reduce(function (r, a) {
  //       r[a.ano_conclusao] = r[a.ano_conclusao] || []
  //       r[a.ano_conclusao].push(a)
  //       return r
  //     }, Object.create(null))

  //     console.log(Object.keys(res))
  //   }
  // },
  methods: {
    mainContent: function () {
      if (this.$route.params.pagina === 'projectos' || this.$route.params.pagina === 'investigacao-e-parcerias') {  // projectos
        let prj = 0
        if (this.$route.query.prj !== undefined) {
          prj = this.$route.query.prj
        }
        this.legislacao = false
        axios.get('https://www.ces.uc.pt/osiris/site/api.php/17643/1/get-projects/osiris?prj=' + prj)
        .then(response => {
          if (prj === 0) {
            this.prjs = response.data
          } else {
            this.prj = response.data
          }
          // this.content = response.data
        })
       .catch(error => {
         console.log(error.data.error.message)
       })
      } else if (this.$route.params.pagina === 'eventos' || this.$route.params.pagina === 'agenda') {               // agenda
        this.legislacao = false
        axios.get('https://www.ces.uc.pt/osiris/site/api.php/17643/1/get-eventos/osiris')
        .then(response => {
          this.content = response.data
        })
       .catch(error => {
         console.log(error.data.error.message)
       })
      } else if (this.$route.params.pagina === 'sala-de-imprensa' || this.$route.params.pagina === 'noticias') {    // noticias
        this.legislacao = false
        axios.get('https://www.ces.uc.pt/osiris/site/api.php/17643/1/get-noticias/osiris')
        .then(response => {
          this.content = {'title': 'Notícias', 'content': response.data}
        })
       .catch(error => {
         console.log(error.data.error.message)
       })
      } else if (this.$route.params.pagina === 'portfolio-2017' || this.$route.params.pagina === 'portfolio') {     // galeria
        this.legislacao = false
        if (this.imgs.length === 0) {
          // axios.get('https://api.flickr.com/services/rest/?method=flickr.photosets.getList&api_key=5a189299a32c16443568e66b74cd9caf&user_id=157816548%40N08&format=json&auth_token=72157662995982778-945066a6d8bc3c9e&api_sig=e5a6620a7ec1e8278ec09e75c28bb482')
          axios.get('https://api.flickr.com/services/rest/?method=flickr.photosets.getList&primary_photo_extras&phot_ids&api_key=e94097a3a156c29a58a5a89cb82bac0c&user_id=157816548%40N08&format=json&nojsoncallback=?')
          .then(response => {
            console.log(response)
            this.photosets = response.data.photosets.photoset
          })
         .catch(error => {
           console.log(error)
         })
        }
      } else if (this.$route.params.pagina === 'opiniao') {                                                         // opinião
        this.legislacao = false
        axios.get('https://www.ces.uc.pt/osiris/site/api.php/17643/1/get-opiniao/osiris')
        .then(response => {
          this.content = {'title': 'Opinião', 'content': response.data}
        })
       .catch(error => {
         console.log(error.data.error.message)
       })
      } else if (this.$route.params.pagina === 'recursos' || this.$route.params.pagina === 'legislacao') {          // legislação
        this.legislacao = true
       // })
      } else {
        this.legislacao = false
        axios.get('https://www.ces.uc.pt/osiris/site/api2.php/17643/1/get-content/' + this.$route.params.pagina)      // conteúdo genérico
        .then(response => {
          this.content = response.data
          this.imgs = response.data.galeria
        })
       .catch(error => {
         console.log(error.data.error.message)
       })
      }
    },
    submenu: function () {
      if (this.$route.params.pagina !== 'inicio') {
        axios.get('https://www.ces.uc.pt/osiris/site/api2.php/' + this.$route.params.pagina + '/1/get-menu')
        .then(response => {
          this.secondary_menu = response.data
          console.log(this.secondary_menu)
          let menus = document.querySelectorAll('ul.nav li a')
          for (let i = 0; i < menus.length; ++i) {
            let menu = menus[i].href.substring(menus[i].href.lastIndexOf('/') + 1, menus[i].href.length)
            if (menu === this.$route.params.pagina || menu === this.content.item_menu) {
              menus[i].parentElement.classList.add('current')
            }
          }
        })
       .catch(error => {
         console.log(error.data.error.message)
       })
      } else {
        axios.get('https://www.ces.uc.pt/osiris/site/api.php/' + this.$route.params.pagina + '/1/get-destaques')
        .then(response => {
          this.secondary_menu = response.data
        })
       .catch(error => {
         console.log(error.data.error.message)
       })
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>

.rightbar a, .rightbar a.visited{
  color: rgb(255,0,0);
    text-decoration: none;
}


.rightbar ul.nav li a {
    padding: 5px 15px;
}

.rightbar ul.nav li a:hover {
  background-color: rgba(0,0,0,0);
  text-decoration: underline;
  color:rgb(255,0,0);
}

.rightbar ul.nav{
  padding: 0px 0px;
}

.rightbar ul.nav li{
  list-style-type: none;
}

.rightbar ul.nav li ul li{
  margin-left: 20px;
}

.rightbar ul.nav li.current>a, .leftbar ul.nav li.current a{
  text-decoration: underline;
  color:rgb(255,0,0);
}


.titulo{
  font-weight: bold;
  color:#444444;
  font-size: 1.5em;
}

.legislacao{
  width: 100%;
  border:0px;
  height: 1000px;
}

.portfolio_img{
  max-height: 80px;
  margin: 5px;
}

.newsletter{
  margin-top: 30px;
}

.projects .ano span{
  font-size: 2em;
  line-height: 2.5em;
}

.projects{
  font-size: .9em;
  line-height: 1.4em;
}

.projects-title{
  font-size: 1.2em;
  font-weight: bold;
  margin-top: 2em;  
}

.projects  ul > li{
  list-style-type: none;
  font-weight: bold;
}

.projects  ul > li > ul > li{
  list-style-type: none;
  font-weight: normal;
}

.project ul li{
  list-style-type: none;
}

.project-title{
  font-weight: bold;
  color: rgb(255,0,0);
  font-size: 1.2em;
  margin-bottom: 1.5em;
}

.project-periodo, .project-duracao{
  font-weight: bold;
  clear: both;
  margin-bottom: 1.2em;
}

.project-periodo div, .project-duracao div{
  font-weight: normal;
}

.project-resumo, .project-resultados, .project-funding, .project-parceiros, .project-keywords, .project-people{
  font-weight: bold;
}

.project-resumo span, .project-resultados span, .project-funding span, .project-parceiros span, .project-keywords span, .project-people span{
  font-weight: normal;
}

.photoset-title{
  text-align: center;
  font-weight:bold;
}

.photoset-description{
  text-align: center;
  margin-bottom:30px;
}

.carousel img{
  max-width: 100% !important;
  width: auto !important;
  height: auto !important;
}

.carousel-titulo{
  padding:10px;
  background-color: rgba(0,0,0,0.5);
  color:#ffffff;
  position: absolute;
  bottom: 10px;
  width: 100%;
  height: 90px;
}

.carousel-subtitulo{
  font-size: 1.4rem;
  color:rgba(255,255,255,0.8)
}

.social-media{
  width:100%;
  margin-top:20px;
  text-align:center;
}

.twitter-timeline{
  box-sizing: border-box;
  margin: 5px;
  margin-top: 40px !important;
}

.fb-page{
  margin: 5px;
  margin-top: 20px;
}

</style>



// WEBPACK FOOTER //
// Content.vue?bc897b86